
import { ButtonSize } from '../types/Button';
import { IconSize } from '../types/Icon';

export const ICON_SIZE_MAP: Record<ButtonSize, IconSize> = {
  [ButtonSize.DEFAULT]: IconSize.DEFAULT,
  [ButtonSize.SMALL]: IconSize.MEDIUM,
  [ButtonSize.LARGE]: IconSize.DEFAULT,
};

export const SPINNER_SIZE_MAP: Record<ButtonSize, number> = {
  [ButtonSize.DEFAULT]: IconSize.DEFAULT,
  [ButtonSize.LARGE]: IconSize.DEFAULT,
  [ButtonSize.SMALL]: IconSize.MEDIUM,
};
